import { CheckIcon } from '@heroicons/react/20/solid'

const CheckmarkWrapper = ({ text }: { text: string }) => {
  return (
    <div className="flex">
      <span className="mx-1 invisible group-data-selected:visible">
        <CheckIcon className="h-5 w-5" aria-hidden="true" />
      </span>
      <div className="block truncate font-normal group-data-selected:font-bold">
        {text}
      </div>
    </div>
  )
}

export default CheckmarkWrapper
